'use client'

import { bindNotebookStoreReader } from './notebook-debug'

/** @type {import('zustand').StoreApi | null} */
let activeNotebookStore = null

export function setActiveNotebookStore(store) {
  activeNotebookStore = store
  bindNotebookStoreReader(() => store.getState())
}

export function clearActiveNotebookStore() {
  activeNotebookStore = null
  bindNotebookStoreReader(() => ({ error: 'notebook store not mounted' }))
}

export function getNotebookStoreApi() {
  if (!activeNotebookStore) {
    throw new Error(
      'Notebook store is not mounted. Use NotebookStoreProvider on /notebook/[id] routes.',
    )
  }
  return activeNotebookStore
}

export function tryGetNotebookStoreApi() {
  return activeNotebookStore
}
